module.exports = require("pdfobject");